import { formatCurrency } from "@/infrastructure/utilities";

export default {
  props: {
    category: {
      type: Object,
      required: true,
    },
    totalCost: {
      type: Number,
      required: true,
    },
  },
  setup() {
    return { formatCurrency };
  },
};
